const overflowedToplistLinks = (
  button = document.querySelector('.fn-toplist__more-links-toggler'),
) => {
  if (button) {
    const links = button.parentNode.querySelectorAll('a')
    const overflowLinksMenu = document.getElementById(button.getAttribute('aria-controls'))
    const topOffset = 10
    let escapeListener
    let outsideClickListener

    const showoverflowLinksMenu = () => {
      overflowLinksMenu.innerHTML = ''
      links.forEach((link) => {
        if (link.offsetTop > topOffset) {
          const clone = link.cloneNode(true)
          clone.removeAttribute('aria-hidden')
          clone.removeAttribute('tabindex')
          overflowLinksMenu.appendChild(clone)
        }
      })
      button.setAttribute('aria-expanded', 'true')
      overflowLinksMenu.removeAttribute('hidden')
      document.addEventListener('keydown', escapeListener)
      document.addEventListener('click', outsideClickListener)
    }

    const hideoverflowLinksMenu = () => {
      button.setAttribute('aria-expanded', 'false')
      overflowLinksMenu.setAttribute('hidden', '')
      document.removeEventListener('keydown', escapeListener)
      document.removeEventListener('click', outsideClickListener)
    }

    const toggleHiddenToplistLinks = (event) => {
      event.stopPropagation()

      if (overflowLinksMenu.hasAttribute('hidden')) {
        showoverflowLinksMenu()
      } else {
        hideoverflowLinksMenu()
      }
    }

    const toplistLinksAttributeUpdater = () => {
      let allToplistLinksVisible = true

      links.forEach((link) => {
        if (link.offsetTop > topOffset) {
          link.setAttribute('aria-hidden', 'true')
          link.setAttribute('tabindex', '-1')
          allToplistLinksVisible = false
        } else {
          link.removeAttribute('aria-hidden')
          link.removeAttribute('tabindex')
        }
      })

      button.removeEventListener('click', toggleHiddenToplistLinks)

      if (allToplistLinksVisible) {
        button.setAttribute('aria-hidden', 'true')
        button.setAttribute('tabindex', '-1')
        button.setAttribute('hidden', '')
      } else {
        button.removeAttribute('aria-hidden')
        button.removeAttribute('tabindex')
        button.removeAttribute('hidden')
        button.addEventListener('click', toggleHiddenToplistLinks)
      }
    }

    let resizeTimer

    escapeListener = (event) => {
      if (event.key === 'Escape') {
        if (overflowLinksMenu.contains(document.activeElement)) {
          button.focus()
        }
        hideoverflowLinksMenu()
      }
    }

    outsideClickListener = (event) => {
      if (!overflowLinksMenu.contains(event.overflowLinksMenu)) {
        hideoverflowLinksMenu()
      }
    }

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        toplistLinksAttributeUpdater()
      }, 250)
    })

    toplistLinksAttributeUpdater()
  }
}

function collapseAnimation(button, elementWrapper, element) {
  function doAfterTransition(event) {
    if (event.propertyName === 'height') {
      if (button.getAttribute('aria-expanded') === 'false') {
        element.classList.add('hidden-sm-down')
      }

      elementWrapper.classList.remove('animating')
      elementWrapper.style.height = ''
      elementWrapper.removeEventListener('transitionend', doAfterTransition)
    }
  }

  function animate(from, to) {
    elementWrapper.style.height = from

    window.setTimeout(() => {
      elementWrapper.removeEventListener('transitionend', doAfterTransition)
      elementWrapper.addEventListener('transitionend', doAfterTransition)
      elementWrapper.style.height = to
    }, 20)
  }

  element.classList.remove('hidden-sm-down')
  const elementHeight = element.getBoundingClientRect().height
  elementWrapper.classList.add('animating')

  if (button.getAttribute('aria-expanded') === 'true') {
    animate('0', `${elementHeight}px`)
  } else {
    animate(`${elementHeight}px`, '0')
  }
}

export function collapseSupportLinks() {
  const buttons = document.querySelectorAll('button[aria-expanded]')
  buttons.forEach(element => element.addEventListener('click', () => {
    const isExpanded = element.getAttribute('aria-expanded')
    const animate = element.classList.contains('fn-animate')
    const targetElement = document.getElementById(element.getAttribute('aria-controls'))
    const targetWrapperElement = targetElement.parentNode
    const toggleClass = element.getAttribute('data-toggle-class')

    if (toggleClass) {
      element.classList.toggle(toggleClass)
    }

    if (isExpanded === 'true') {
      element.setAttribute('aria-expanded', 'false')

      if (animate) {
        collapseAnimation(element, targetWrapperElement, targetElement)
      } else {
        targetElement.classList.add('hidden-sm-down')
      }
    } else {
      element.setAttribute('aria-expanded', 'true')

      if (animate) {
        collapseAnimation(element, targetWrapperElement, targetElement)
      } else {
        targetElement.classList.remove('hidden-sm-down')
      }
    }
  }))
}

export default overflowedToplistLinks
